import React, { useEffect } from 'react'
import minuteMedia from 'lib/minute-media'
import ExternalProvider, { providers } from 'components/ExternalProvider'

function _MinuteMediaAd() {
  // Effect to add minute media scripts on component mount, remove on unmount
  useEffect(() => {
    minuteMedia.loadScript()
  }, [])

  return (
    <>
      <div className='jsx-2462984785 bs-minuteMediaAd'>
        <br />
      </div>
    </>
  )
}

export default function MinuteMediaAd({ ...args }) {
  return (
    <ExternalProvider name={providers.minutemedia}>
      <_MinuteMediaAd {...args} />
    </ExternalProvider>
  )
}
